import styled from '@emotion/styled';

export const EmailStatusIcon = styled('div')`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;
